import "./style.css"

const ServiceItem = (props) => {
    const itemData = props.serviceData;

    return <a href={itemData['href']} className="wrapping_a">
        <img src={itemData['img']} className={'item-img img-' + itemData['id']}/>
        <div className="item-data">
            <div className="item-title">
                <p className="title-text">{itemData['title']}</p>
            </div>
            <div className="item-description">
                <p className="description-text">{itemData['description']}</p>
            </div>
            <button className="item-button"  >
                <p className="button-text">Попробовать</p>
            </button>
        </div>
    </a>
}

export default ServiceItem;